<template>
  	<AddDnsBatch />
</template>

<script>

// @ is an alias to /src
import AddDnsBatch from "../components/AddDnsBatch.vue";

export default {
  name: "AddPinBatchs",
  components: {
    AddDnsBatch,
  },
};
</script>
